import { observer } from 'mobx-react-lite';
import { useEventMetadataStore } from '../../../event-panel-form/event-metadata';
import { TabBody } from '../../../../panels/entity-panels/tabs/tab-body';
import { VStack } from '@cad-arc';
import { MergedEventsSection } from './sections/merged-events-section';
import { DuplicateEventsSection } from './sections/duplicate-events-section';
import { useEnabledFeatures } from '../../../../common/hooks/enabled-features/use-enabled-features';

export const MergedEventsTabExistingEvent = observer(function MergedEventsTabExistingEvent({
    eventId,
}: {
    eventId: number;
}) {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const isScheduledEvent = eventMetadata?.isScheduledEvent;
    const { searchForDuplicateEvents } = useEnabledFeatures();
    return (
        <TabBody>
            <VStack gap={14}>
                {!isScheduledEvent && <MergedEventsSection eventId={eventId} />}
                {searchForDuplicateEvents && (
                    <DuplicateEventsSection
                        latitude={eventMetadata?.eventLocationLatitude}
                        longitude={eventMetadata?.eventLocationLongitude}
                        locationId={eventMetadata?.eventLocationId}
                        eventId={eventId}
                    />
                )}
            </VStack>
        </TabBody>
    );
});
